import { type ReactNode } from 'react';
import { GripVertical, X } from 'lucide-react';

export function DragHandle({
  locked,
  listeners,
  attributes,
}: {
  locked: boolean;
  listeners?: object | undefined;
  attributes?: object | undefined;
}): ReactNode {
  if (locked) return <span className="w-[14px]" />;
  return (
    <button
      {...listeners}
      {...attributes}
      className="cursor-grab text-text-tertiary/40 hover:text-text-tertiary active:cursor-grabbing"
    >
      <GripVertical size={14} />
    </button>
  );
}

export function RemoveButton({
  canRemove,
  onRemove,
}: {
  canRemove: boolean;
  onRemove: () => void;
}): ReactNode {
  if (!canRemove) return <span className="w-[16px]" />;
  return (
    <button
      onClick={onRemove}
      className="p-0.5 text-text-tertiary/40 hover:text-error"
    >
      <X size={12} />
    </button>
  );
}
